import { Oval } from "react-loader-spinner"
import React, { useEffect, useState } from "react";

function Loader(){
    return (
        <Oval
            ariaLabel="loading-indicator"
            height={100}
            width={100}
            strokeWidth={5}
            color="#3999F9"
            secondaryColor="grey"
        />
    );
}

export default Loader;
